@if (!submitWarningPopup) {
<div class="modal-content" cdkTrapFocus [cdkTrapFocusAutoCapture]="false">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">
      {{ "SAVE_EXIT_STATIC_TEXT1" | globalTranslate }}
    </h1>
    <button
      type="button"
      class="btn-close pull-right"
      [attr.aria-label]="'CLOSE' | globalTranslate"
      (click)="onCancel()"
    >
      <img
        src="../../assets/images/⚛️ icons-close-circle-outline.svg"
        alt="close-icon"
      />
    </button>
  </div>
  <div class="modal-body">
    <h2 class="page-header" role="heading" aria-level="1">
      {{ "SAVE_EXIT_STATIC_TEXT1" | globalTranslate }}
    </h2>
    <div class="row">
      <div class="p-4">
        <div
          tabindex="0"
          class="card card-body shadow mb-2 p-3 p-md-4 d-flex flex-column flex-md-row align-items-start align-items-md-center align-items-sm-center text-center text-md-start"
          [ngClass]="{ applyColor: appType === 'atglance' }"
          (click)="select('atglance')"
          role="button"
        >
          <div
            class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
          >
            <img
              class="col dot"
              src="../../../../assets/images/Icons/S&E_save.svg"
              alt=""
            />
          </div>
          <div class="flex-grow-1 min-w-0 w-100 text-start">
            <h2 class="tile_header">
              @if (!isPreterm) {
              <span
                >{{ "SAVE_EXIT_STATIC_TEXT2" | globalTranslate }}
                {{ appKeyWord | globalTranslate }}
                {{ "SAVE_EXIT_STATIC_TEXT3" | globalTranslate }}</span
              >
              } @if (isPreterm) {
              <span>{{ "SAVE_EXIT_STATIC_TEXT2_QFR" | globalTranslate }}</span>
              }
            </h2>
            @if (!isPreterm) {
            <div>
              <span class="tile-text"
                >{{ "SAVE_EXIT_STATIC_TEXT4" | globalTranslate }}
                {{ appKeyWord | globalTranslate }}. @if (!isRenewal) {
                <label class="notbold">{{
                  "SAVE_EXIT_STATIC_TEXT5" | globalTranslate
                }}</label>
                } @if (isRenewal) {
                <label class="notbold">{{
                  "SAVE_EXIT_STATIC_TEXT19" | globalTranslate
                }}</label>
                } {{ appKeyWord | globalTranslate
                }}{{ "SAVE_EXIT_STATIC_TEXT6" | translate }}.</span
              ><br /><br />
              <span class="tile-text"
                >{{ "SAVE_EXIT_STATIC_TEXT7" | globalTranslate }}
                {{ appKeyWord | globalTranslate }} </span
              >@if (!mobileUser) {
              <span
                class="tile-text"
                [innerHTML]="'SAVE_EXIT_STATIC_TEXT8' | globalTranslate"
                >{{ "SAVE_EXIT_STATIC_TEXT8" | globalTranslate }}</span
              >
              }@if (mobileUser) {
              <span
                class="tile-text"
                [innerHTML]="'SAVE_EXIT_STATIC_TEXT20' | globalTranslate"
                >{{ "SAVE_EXIT_STATIC_TEXT20" | globalTranslate }}</span
              >
              }<br /><br />
              <span class="tile-text">{{
                "SAVE_EXIT_STATIC_TEXT9" | globalTranslate
              }}</span>
            </div>
            } @if (isPreterm) {
            <div>
              <span class="tile-text">{{
                "SAVE_EXIT_STATIC_TEXT4_QFR" | globalTranslate
              }}</span>
            </div>
            }
          </div>
        </div>
        <div
          tabindex="0"
          class="card card-body shadow mb-2 p-3 p-md-4 d-flex flex-column flex-md-row align-items-start align-items-md-start align-items-sm-center text-center text-md-start"
          [ngClass]="{ applyColor: appType === 'continue' }"
          (click)="select('continue')"
          role="button"
        >
          <div
            class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
          >
            <img
              class="col dot"
              src="../../../../assets/images/Icons/S&E_continue.svg"
              alt=""
            />
          </div>
          <div class="flex-grow-1 min-w-0 w-100 pt-md-4 text-start">
            <h2 class="tile_header">
              @if (!isPreterm) {
              <span
                >{{ "SAVE_EXIT_STATIC_TEXT10" | globalTranslate }}
                {{ appKeyWord | globalTranslate }}</span
              >
              } @if (isPreterm) {
              <span>{{ "SAVE_EXIT_STATIC_TEXT10_QFR" | globalTranslate }}</span>
              }
            </h2>
            @if (!mobileUser) {
            <span
              class="tile-text"
              [innerHTML]="'SAVE_EXIT_STATIC_TEXT11' | globalTranslate"
              >{{ "SAVE_EXIT_STATIC_TEXT11" | globalTranslate }}</span
            >
            } @if (mobileUser) {
            <span
              class="tile-text"
              [innerHTML]="'SAVE_EXIT_STATIC_TEXT21' | globalTranslate"
              >{{ "SAVE_EXIT_STATIC_TEXT21" | globalTranslate }}</span
            >
            }
          </div>
        </div>
        @if (showSubmitTab() && !isPresumptive) {
        <div
          tabindex="0"
          class="card card-body shadow mb-2 p-3 p-md-4 d-flex flex-column flex-md-row align-items-start align-items-md-center align-items-sm-center text-center text-md-start"
          [ngClass]="{ applyColor: appType === 'submit' }"
          (click)="select('submit')"
          role="button"
        >
          <div
            class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
          >
            <img
              class="col dot"
              src="../../../../assets/images/Icons/S&E_submit.svg"
              alt=""
            />
          </div>
          <div class="flex-grow-1 min-w-0 w-100 text-start">
            <h2 class="tile_header">
              @if (!isPreterm) {
              <span
                >{{ "SAVE_EXIT_STATIC_TEXT12" | globalTranslate }}
                {{ appKeyWord | globalTranslate }}.</span
              >
              } @if (isPreterm) {
              <span>{{ "SAVE_EXIT_STATIC_TEXT12_QFR" | globalTranslate }}</span>
              }
            </h2>
            @if (!isPreterm) {
            <span class="tile-text">
              {{ "SAVE_EXIT_STATIC_TEXT13" | globalTranslate }}
              {{ appKeyWord | globalTranslate }}
              {{ "SAVE_EXIT_STATIC_TEXT14" | globalTranslate }}
            </span>
            } @if (isPreterm) {
            <span class="tile-text">
              {{ "SAVE_EXIT_STATIC_TEXT13_QFR" | globalTranslate }}
            </span>
            }<br /><br />
            <span class="tile-text">{{
              "SAVE_EXIT_STATIC_TEXT15" | globalTranslate
            }}</span>
          </div>
        </div>
        }<br />
        @if (!mobileUser && !isPreterm) {
        <div>
          {{ "SAVE_EXIT_STATIC_TEXT16" | globalTranslate }}
          {{ appKeyWord | globalTranslate }},
          <span [innerHTML]="'SAVE_EXIT_STATIC_TEXT17' | globalTranslate">{{
            "SAVE_EXIT_STATIC_TEXT17" | globalTranslate
          }}</span>
          {{ appKeyWord | globalTranslate
          }}{{ "SAVE_EXIT_STATIC_TEXT18" | globalTranslate }}
        </div>
        } @if (!mobileUser && isPreterm) {
        <div>{{ "SAVE_EXIT_STATIC_TEXT16_QFR" | globalTranslate }}</div>
        }
      </div>
    </div>
  </div>
  <div class="modal-footer d-block p-md-3 p-0">
    <div class="row g-md-3 g-0 justify-content-center justify-content-lg-end">
      <div class="col-11 col-lg-3">
        <button
          id="SaveContinue"
          id="dialog"
          class="btn w-100 d-grid btn-secondary"
          (click)="next()"
          [disabled]="!selectionMade"
        >
          {{ "NEXT" | globalTranslate }}
        </button>
      </div>
    </div>
  </div>
</div>
} @if (submitWarningPopup) {
<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">
      {{ "Warning" | globalTranslate }}
    </h1>
    <button
      type="button"
      class="btn-close pull-right"
      [attr.aria-label]="'CLOSE' | globalTranslate"
      (click)="onCancel()"
    >
      <img
        src="../../assets/images/⚛️ icons-close-circle-outline.svg"
        alt="close-icon"
      />
    </button>
  </div>
  <div class="modal-body">
    <p>
      {{ "EBMS_EXIT_POPUP_MSG" | globalTranslate
      }}<strong>{{ "GO_BACK_TO_APPLICATION" | globalTranslate }}</strong
      >{{ "EBMS_EXIT_POPUP_MSG1" | globalTranslate }}
    </p>
  </div>
  <div class="modal-footer justify-content-end">
    <div class="me-2 ml-2">
      <button
        type="button"
        id="dialog"
        class="btn d-grid btn-secondary"
        (click)="onConfirm()"
      >
        {{ "SUBMIT" | globalTranslate }}
      </button>
    </div>
    <div class="me-2 ml-2">
      <button
        type="button"
        id="dialog"
        class="btn d-grid btn-link"
        (click)="onCancel()"
      >
        {{ "GO_BACK_TO_APPLICATION" | globalTranslate }}
      </button>
    </div>
  </div>
</div>
}